import React from 'react';
import cx from 'classnames';
import { isNull } from 'lodash';

import CardLayout from '@magoosh/layouts/card';
import ProgressBar from '@magoosh/lib/progress_bar';
import { pluralize } from 'utilities/pluralize';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  previousScore: number;
  score: number;
  scoreRange: {
    max: number;
    min: number;
  };
  status: string;
}

export default (props: Props) => {
  return (
    <CardLayout.Card className={cx(style.scoreCard, 'd-flex flex-column gap-m')}>
      <div>
        <h3 className="u-margin-A-n">
          Score
          {(() => {
            if (props.status === 'finished') {
              return <>{' '}<strong>{isNull(props.score) ? 'NS' : props.score}</strong></>;
            } else {
              return null;
            }
          })()}
        </h3>
      </div>

      <div className="align-items-center d-flex gap-s">
        <div className="flex-1" style={{ minWidth: 250 }}>
          <ProgressBar
            backgroundColor={colors.grayLighter}
            color="linear-gradient(90deg, rgb(55, 145, 237), rgb(113, 78, 246))"
            percentage={props.score ? (props.score / props.scoreRange.max) * 100 : 0}
            size="md"
          />
        </div>

        <div className="flex-none small">
          out of {props.scoreRange.max}
        </div>
      </div>

      {(() => {
        if (!props.previousScore || !props.score) {
          return null;
        } else if (props.previousScore == props.score) {
          return (
            <small>About the same as your last attempt</small>
          );
        } else if (props.previousScore > props.score) {
          return (
            <small>{pluralize(props.previousScore - props.score, 'point')} lower than your last attempt</small>
          );
        } else {
          return (
            <small>🎉 {pluralize(props.score - props.previousScore, 'point')} higher than your last attempt</small>
          );
        }
      })()}
    </CardLayout.Card>
  );
}
